require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-gmmorris-bs-rewire.json") })
        }
      }, "path---package-gmmorris-bs-rewire");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-gmmorris-bs-rewire!./.cache/json/package-gmmorris-bs-rewire.json
// module id = 868
// module chunks = 231608221292675